import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px;
  width: 20px;
  height: 20px;
  border-radius: 8px;
  background-color: ${(props) => props.color};
  border: 2px solid rgba(0, 0, 0, 0.35);
  transition: all ease-in-out 150ms;

  :hover {
    transform: scale(1.2);
    transition: all ease-in-out 150ms;
  }

  /* Make checkmark white in black circle */
  ${(props) =>
    !!props.selected &&
    `
      transform: scale(1.2);
      border-color: rgba(0, 0, 0, 0.75);

      :nth-child(2) svg path {
        fill: white !important;
      }`}
`;

const ColorButton = ({ rgb, selected, onClick }) => (
  <Container
    href="#"
    color={`rgb(${rgb[0]},${rgb[1]},${rgb[2]})`}
    selected={selected}
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  />
);

ColorButton.propTypes = {
  rgb: PropTypes.arrayOf(PropTypes.number).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ColorButton.defaultProps = {
  selected: false,
};

export default ColorButton;
